/**
 * This Software is the property of dotfly and is protected
 * by copyright law - it is NOT Freeware.
 *
 * Any unauthorized use of this software without a valid license key
 * is a violation of the license agreement and will be prosecuted by
 * civil and criminal law.
 *
 * @category   Hide Billing Form Business Fields
 * @author     Julius Veltmann <julius.veltmann@dotfly.de>
 * @license    http://www.dotfly.de Commercial
 * @link       http://www.dotfly.de
 */

var needHelp        = document.querySelectorAll('.c-needhelp');

if (needHelp) {

    needHelp.forEach( item => {
        var triggerOpen         = item.querySelector('.js-helptrigger');
        var triggerClose        = item.querySelector('.js-helptrigger-close');
        var visibleContainer    = item.querySelector('.c-needhelp__content');

        triggerOpen.addEventListener('click', function () {
            visibleContainer.classList.add('is--visible');
        });

        triggerClose.addEventListener('click', function () {
            visibleContainer.classList.remove('is--visible');
        });

    });
};